import React, { useState, useEffect, Suspense } from 'react';
import { Router, View } from 'react-navi';
import Layout from './Layout';
import { routes } from '../routes';
import { getProfile } from '../api';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import config from '../config';
import { QueryClient, QueryClientProvider } from 'react-query';
const theme = createTheme({
    palette: {
        primary: {
            main: '#d6670d',
        },
    },
    typography: {
        useNextVariants: true,
        fontFamily: "'Source Sans Pro', sans-serif",
    },
    overrides: {
        MUIDataTable: {
            paper: {
                boxShadow:
                    '0px 5px 5px 0px rgba(0, 0, 0, 0.14), 0px 10px 10px 0px rgba(0, 0, 0, 0.12)',
                borderRadius: 0,
            },
        },
        MuiInputBase: {
            input: {
                color: '#d6670d',
            },
        },
        MUIDataTableFilterList: {
            root: {
                paddingBottom: '24px',
            },
        },
        MuiAppBar: {
            colorPrimary: {
                backgroundColor: '#fff',
                background: `url(${config.baseV1Url}/img/header_bg.jpeg) repeat-x top left`,
            },
        },
        MUIDataTableHeadCell: {
            fixedHeader: {
                whiteSpace: 'nowrap',
                color: '#333',
                fontSize: '1em',
                fontWeight: '600',
            },
        },
        MuiTabs: {
            root: {
                minHeight: '30px',
            },
        },
        MuiTab: {
            root: {
                backgroundColor: '#d6b581',
                marginLeft: '2px',
                padding: 0,
                minHeight: '30px',
                '@media (min-width: 960px)': {
                    minWidth: 'auto',
                    padding: '0 10px',
                },
            },
            textColorPrimary: {
                color: '#fff',
                '&$selected': {
                    backgroundColor: '#452914',
                    color: '#fff',
                },
            },
        },
        PrivateTabIndicator: {
            colorPrimary: {
                backgroundColor: '#d6670d',
            },
        },
        MuiTable: {
            root: {
                tableLayout: 'fixed',
            },
        },
        MuiTableCell: {
            root: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
            head: {
                color: 'rgba(0, 0, 0, 0.87)',
                fontSize: '16px',
                fontWeight: '600',
            },
        },
        MuiTableSortLabel: {
            root: {
                '&$active': {
                    color: '#d6670d',
                },
            },
        },
        MuiTooltip: {
            tooltip: {
                fontSize: '0.9em',
            },
        },
    },
});
const queryClient = new QueryClient();
export const App = () => {
    const [isAuthenticationStateKnown, setIsAuthenticationStateKnown] =
        useState(false);
    const [currentUser, setCurrentUser] = useState();
    useEffect(() => {
        getProfile()
            .then((profile) => {
                setCurrentUser(profile);
                setIsAuthenticationStateKnown(true);
            })
            .catch((e) => {
                if (e.response.status === 401) {
                    setIsAuthenticationStateKnown(true);
                    // Unauthorized
                    // window.location.href = '/login';
                } else {
                    console.log(e);
                }
            });
    }, []);
    return (
        <Router
            routes={routes}
            context={{ isAuthenticationStateKnown, currentUser }}
        >
            <MuiThemeProvider theme={theme}>
                <Layout {...{ isAuthenticationStateKnown, currentUser }}>
                    <QueryClientProvider client={queryClient}>
                        <Suspense fallback={null}>
                            <View />
                        </Suspense>
                    </QueryClientProvider>
                </Layout>
            </MuiThemeProvider>
        </Router>
    );
};
